import { createContext, use } from 'react';

export type SortableItemContextType = {
  handleRef(node: HTMLElement | null): void;
};

export const SortableItemContext = createContext<SortableItemContextType>({
  handleRef() {},
});

export const useSortableItemContext = () => use(SortableItemContext);
